/* Placeholder for tabs without a dedicated screen yet (Reports, Remedies). */
export default function PlaceholderTab({ label }) {
  return (
    <div className="dash-card p-12 text-center">
      <div className="w-14 h-14 mx-auto rounded-full bg-[#3D0A0A] text-[#D4A017] flex items-center justify-center text-2xl mb-4">॰</div>
      <h3 className="text-xl font-royal text-[#3D0A0A]">{label}</h3>
      <p className="text-sm text-stone-500 mt-2">This section is coming next.</p>
    </div>
  )
}
